import { styled } from '@mui/material'

export const AutocompleteGroupItems = styled('ul')({
	padding: 0,
})
